<template>
  <div class="feeTypeListRratePage">
    <div class="mb10">
      <Button type="primary" @click="addTbalRow" v-if="isEdit">新增费用</Button>
    </div>
    <Form ref="pageFromRef" :model="formData" :rules="ruleValidate" :label-width="100" class="fmb0 flex1">
      <Table border :columns="sewingColumns" :data="formData.tableData">
        <template slot-scope="{ row, index }" slot="amount">
          <FormItem
            label=""
            :prop="`tableData.${index}.amount`"
            class="item-input"
            :label-width="0"
            :rules="tableRule.amount"
            v-if="isEdit"
          >
            <Input v-model="formData.tableData[index].amount" placeholder="请输入金额， 大于0且最多2位小数" />
          </FormItem>
          <span v-else>{{ row.amount }}</span>
        </template>
      </Table>
    </Form>
    <div class="table-footer">
      <div class="seat"></div>
      <div class="fmb0 flex1"></div>
      <div class="flex1">合计：{{ totalPrice }}</div>
    </div>
    <Spin v-if="pageLoading" fix></Spin>
    <Modal v-model="productInfo.dialogVisible" width="800" title="新增其他费用" :mask-closable="false" :closable="false">
      <div>
        <Form ref="modalProductRef" :model="productInfo.searchFormData" inline :label-width="80" class="fmb16 formSearch">
          <FormItem label="费用类型:" prop="feeTypeName" style="width: 300px;">
            <Input v-model="productInfo.searchFormData.feeTypeName" :clearable="true" placeholder="请输入，支持模糊查询" />
          </FormItem>
          <FormItem label="" :label-width="0">
            <Button type="primary" @click="modalTbaleSearch">查询</Button>
            <Button style="margin-left:10px;" @click="resetModalForm" icon="md-refresh">重置</Button>
          </FormItem>
        </Form>
        <Table
          border
          :columns="productInfo.modalTableColumns"
          :data="productInfo.modalTableData"
          max-height="460"
          @on-selection-change="selectChange"
          ref="selection"
          :loading="productInfo.tableLoading"
        />
        <div style="text-align:right;" class="mt10">
          <page-common
            :pageConfig="productInfo.proPage"
            @ChangePage="ChangePage"
            @ChangePageSize="ChangePageSize"
          />
        </div>
      </div>
      <div slot="footer">
        <Button @click="productInfo.dialogVisible = false">取消</Button>
        <Button type="primary" @click="handleNext">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api.js';
import pageCommon from './pageCommon';

export default {
  name: "feeTypeListRrate",
  components: { pageCommon },
  props: {
    // 是否显示
    modelVisible: { type: Boolean, default: false },
    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 商品数据
    productData: { type: Object, default () { return {} } }
  },
  data() {
    return {
      pageLoading: false,
      formData: {
        tableData: [],
      },
      ruleValidate: {},
      tableRule: {
        amount: [
          { required: true, validator: this.$common.validatorMaxNumber, min: 0, notIncludes: ['min'], point: 2, msg: '请输入数字,限两位小数', trigger: 'change' },
          { required: true, validator: this.$common.validatorMaxNumber, min: 0, notIncludes: ['min'], point: 2, msg: '请输入数字,限两位小数', trigger: 'blur' },
        ]
      },
      sewingTableCol: [
        {
          title: '费用类型',
          key: 'feeTypeName',
          align: 'center',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.isDeleted) || row.isDeleted == 0) return h('span', {}, row.feeTypeName);
            return h('span', {}, [
              h('div', {}, row.feeTypeName),
              h('div', {
                style: {
                  color: '#f20'
                }
              }, '(已删除)')
            ])
          }
        },
        {
          title: '金额（元）',
          slot: 'amount',
          align: 'center',
        }
      ],
      formValidate: {},
      productInfo: {
        dialogVisible: false,
        searchFormData: {
          feeTypeName: '',
        },
        proPage: {
          total: 0,
          pageNum: 1,
          pageSize: 10,
        },
        modalTableColumns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '费用类型',
            key: 'feeTypeName',
            align: 'center',
          },
        ],
        modalTableData: [],
        checkedList: [],
        tableLoading: false,
      },
    };
  },
  watch: {
    modelVisible: {
      immediate: true,
      deep: true,
      handler (val) {
        if (!val) return this.resetData();
        this.$nextTick(() => {
          this.pageInit(this.feeTypeData || []);
          setTimeout(() => {
            this.pageInit(this.feeTypeData);
          }, 300)
        })
      }
    }
  },
  computed: {
    // 费用数据
    feeTypeData () {
      if (this.$common.isEmpty(this.productData) || this.$common.isEmpty(this.productData.productFeeTypeList)) return [];
      return this.$common.copy(this.productData.productFeeTypeList);
    },
    // 是否可编辑
    isEdit () {
      return !this.disabled;
    },
    // 列表列设置
    sewingColumns () {
      const operation = {
        title: '操作',
        key: 'index',
        width: '120',
        align: 'center',
        render: (h, { row, index }) => {
          return h('div', {
            style: {
              display: 'inline-block',
              cursor: 'pointer',
              color: '#2d8cf0',
            },
            on: {
              'click': () => {
                this.$Modal.confirm({
                  title: '操作',
                  content: `<div>确认移除费用类型：<span style="color:#f20;">${row.feeTypeName}</span>？</div>`,
                  loading: true,
                  onOk: () => {
                    this.$Modal.remove();
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.formData.tableData.splice(index, 1);
                  }
                });
              }
            }
          }, '移除')
        },
      }
      return this.isEdit ? [operation, ...this.sewingTableCol] : this.sewingTableCol;
    },
    // 价格计算
    totalPrice() {
      if (this.$common.isEmpty(this.formData.tableData)) return '0.00';
      const values = this.formData.tableData.map(item => Number(item['amount'] || 0));
      const total = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
      return total.toFixed(2);
    },
  },
  created() {},
  methods: {
    pageInit (datas) {
      this.pageLoading = true;
      let awaitRes = [
        () => {
          return this.detail(datas);
        }
      ];
      this.$common.promiseAll(awaitRes).then(resArr => {
        this.pageLoading = false;
      }).catch(() => {
        this.pageLoading = false;
      })
    },
    // 重置数据
    resetData () {
      this.formData.tableData = [];
      this.formValidate = {}
    },
    detail (temps) {
      return new Promise((resolve) => {
        if (this.$common.isEmpty(temps)) return resolve(temps);
        this.formData.tableData = temps;
        resolve(temps);
      })
    },
    // 返回表单值 type 为 1 时验证， 其他值不验证
    getFormData (type) {
      return new Promise((resolve) => {
        if (type != 1) {
          resolve({
            success: true,
            data: this.formData.tableData
          });
          return;
        }
        this.$refs.pageFromRef.validate((valid) => {
          if (!valid) {
            this.$Message.error('“其他费用”表单验证不通过，请检查');
            return resolve({ success: false, message: '“其他费用”表单验证不通过，请检查' });
          }
          resolve({
            success: true,
            data: this.formData.tableData
          });
        })
      })
    },
    // 新增列表行
    addTbalRow () {
      this.productInfo.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.modalProductRef.resetFields();
        this.$refs.selection.selectAll(false);
      })
      this.modalTbaleSearch();
    },
    modalTbaleSearch () {
      this.productInfo.proPage.pageNum = 1;
      this.getList();
    },
    resetModalForm () {
      this.$refs.modalProductRef.resetFields();
    },
    getList() {
      let temp = this.$common.removeEmpty({ ...this.productInfo.searchFormData, ...this.productInfo.proPage });
      delete temp.total;
      this.productInfo.tableLoading = true;
      this.axios.post(api.laPaFeeTypeList, temp).then((res) => {
        if (res.data && res.data.datas) {
          const idList = this.formData.tableData.map(m => m.feeTypeId);
          this.productInfo.modalTableData = (res.data.datas.list || []).map(row => {
            // (1:已删除,0:未删除)
            return {
              ...row,
              isDeleted: 0,
              _disabled: idList.includes(row.feeTypeId)
            }
          });
          this.productInfo.proPage.total = res.data.datas.total || 0;
          this.$refs.selection.selectAll(false);
          this.productInfo.checkedList = [];
        }
      }).finally(() => {
        this.productInfo.tableLoading = false;
      });
    },
    // 表格多项选择
    selectChange(list) {
      this.productInfo.checkedList = list;
    },
    // 返回pageSize
    ChangePageSize(pageSize) {
      this.productInfo.proPage.pageSize = pageSize;
      this.getList();
    },
    // 返回page
    ChangePage(page) {
      this.productInfo.proPage.pageNum = page;
      this.getList();
    },
    handleNext() {
      let list = this.productInfo.checkedList;
      if (!list.length) {
        this.$Message.warning('请勾选要添加的其他费用类型!');
        return;
      }
      const idList = this.formData.tableData.map(m => m.feeTypeId);
      list = list.filter(f => !idList.includes(f.feeTypeId));
      this.formData.tableData = [...this.formData.tableData, ...list];
      this.productInfo.dialogVisible = false;
    },
  }
};
</script>
<style lang="less" scoped>
.feeTypeListRratePage {
  position: relative;
  padding: 10px;
  .table-footer {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border: 1px solid #dcdee2;
    border-top: none;
    background-color: #f8f8f9;

    .seat {
      width: 120px;
    }

    .flex1 {
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
  :deep(.item-input) {
    &.ivu-form-item {
      margin: 0;
    }
  }
}
</style>
